/* eslint-disable quotes */
import { Component } from '@angular/core';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { IEventAction } from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { PurchaseOrderService } from './purchase-order.service';
import {
  INVOICESTATUS_ID,
  IPurchaseOrder,
  ORDERSTATUS_ID,
  PURCHASE_ORDER_TTL_ES,
  RECEPTIONSTATUS_ID
} from './purchase-order.interface';
import { MessageService } from 'primeng/api';
import { PurchaseOrderReceptionService } from '../purchase-order-reception/purchase-order-reception.service';
import { PurchasesService } from '../quick-purchase/purchases.service';

@Component({
  selector: 'pg-purchase-order',
  templateUrl: './purchase-order.component.html',
  providers: [MessageService]
})
export class PurchaseOrderComponent extends TableActionsTemplate {
  dataDocument: any;
  showOpenPurchaseOrderCreate = false;
  showOpenPurchaseOrderUpdate = false;
  confirmSettings = {};
  prueba = 0;
  dataDocumentEdit: any;
  displayResponsive = false;
  data: any;
  viewCompleteState = false;
  fieldsToUpdate;
  precioTotal;
  dataReception;
  detail;
  estadoOC = [
    { label: 'REGULADOS', value: '1' },
    { label: 'NO REGULADOS', value: '2' },
    { label: 'NO ', value: '3' }
  ];
  suscriptionReception$: any;
  viewCompleteStateButton: boolean;
  constructor(
    private serviceBase: PurchaseOrderService,
    private purchasesService: PurchasesService,
    private purchaseOrderReceptionService: PurchaseOrderReceptionService,
    private messageService: MessageService
  ) {
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.viewCompleteState = false;
    this.table.settings = {
      title: PURCHASE_ORDER_TTL_ES,
      columns: [
        { header: 'Proveedor', field: 'providerName' },
        { header: 'Documento', field: 'numberDocument' },
        { header: 'Fecha de Entrega', field: 'delivery_at', pipe: 'Date' },
        { header: 'Término de Pago', field: 'paymentTermsId' },
        { header: 'Impuesto', field: 'taxId' },
        { header: 'Estado OC', field: 'orderStatusName' },
        { header: 'Estado Recepcion', field: 'receptionStatusName' },
        { header: 'Estado Factura', field: 'invoiceStatusName' }
      ]
    };
    this.table.actionsHead = [
      {
        name: 'create',
        icon: 'pi pi-plus',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Registrar Orden de Compra'
      }
    ];
    this.table.actions = [
      {
        name: 'edit',
        icon: 'pi pi-pencil',
        class: 'p-button-rounded p-button-warning',
        pTooltip: 'Actualizar Orden de Compra'
      },
      {
        name: 'see-details',
        icon: 'pi pi-eye',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Ver detalles'
      },
      {
        name: 'confirm',
        icon: 'pi pi-check-square',
        class: 'p-button-rounded p-button-success',
        pTooltip: 'Completar Orden de Compra'
      },
      {
        name: 'delete',
        icon: 'pi pi-trash',
        class: 'p-button-rounded p-button-danger',
        pTooltip: 'Eliminar Orden de Compra'
      }
    ];
    this.initSubscriptions$();
    this.prueba = 60;
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IPurchaseOrder[]) => {
        this.parseToTable(data);
      });
    this.suscriptionReception$ = this.purchaseOrderReceptionService
      .getData$()
      .subscribe((data) => {
        this.dataReception = data;
      });
  }

  onReciveAction(event: IEventAction): void {
    const { data, action } = event;
    if (action === 'see-details') {
      this.dataDocument = data;
    }
    if (action === 'edit') {
      if (
        data['orderStatusId'] == 2 ||
        data['orderStatusId'] == 3 ||
        data['orderStatusId'] == 3
      ) {
        if (data['orderStatusId'] == 2) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Orden de compra ha sido Aprobada',
            detail:
              'No está permitido hacer cambios a una Orden de Compra Aprobada.'
          });
        }
        if (data['orderStatusId'] == 3) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Orden de compra ha sido Rechazada',
            detail:
              'No está permitido hacer cambios a una Orden de Compra Rechazada.'
          });
        }
        if (data['orderStatusId'] == 5) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Orden de compra ha sido Completada',
            detail: 'No está permitido hacer cambios a una Orden de Completada'
          });
        }
      } else {
        this.dataDocumentEdit = data;
        this.showOpenPurchaseOrderUpdate = true;
      }
    }
    if (action === 'confirm') {
      if (data['orderStatusId'] == 3) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Orden de compra ha sido Rechazada',
          detail: 'La Orden de Compra se encuentra Rechazada.'
        });
      } else {
        if (data['orderStatusId'] == 5) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Orden de compra ha sido Completada',
            detail:
              'Los productos se encuentran en el Almacén. \nVisualizar Reporte de Compras.'
          });
        } else {
          if (data['orderStatusId'] == 1) {
            this.viewCompleteState = true;
          } else {
            this.viewCompleteState = false;
            if (
              data['invoiceStatusId'] == 3 &&
              data['receptionStatusId'] == 3
            ) {
              this.viewCompleteStateButton = true;
            } else {
              this.viewCompleteStateButton = false;
            }
          }
          this.displayResponsive = true;
          this.data = data;
        }
      }
    }
    if (action === 'delete') {
      if (data['orderStatusId'] == 2) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Orden de compra ha sido Aprobada',
          detail: 'No está permitido eliminar  una Orden de Compra Aprobada.'
        });
      } else {
        if (data['orderStatusId'] == 5) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Orden de compra ha sido Completada',
            detail: 'No está permitido hacer cambios a una Orden de Completada'
          });
        } else {
          this.confirmSettings = {
            message: 'Eliminar Orden de Compra',
            action: 'delete',
            data
          };
        }
      }
    }
  }

  onReciveActionHead(event: IEventAction): void {
    if (event) {
      const { data, action } = event;
      if (action === 'create') {
        this.showOpenPurchaseOrderCreate = true;
      }
    }
  }

  async actionConfirmed(event) {
    const { action, data } = event;
    if (action == 'approve') {
      this.displayResponsive = false;
      const id = data.id;
      this.fieldsToUpdate = {
        document: {
          delivery_at: data.delivery_at,
          providerId: data.providerId,
          paymentTermsId: data.paymentTermsId,
          taxId: data.taxId,
          orderStatusId: 2,
          receptionStatusId: data.receptionStatusId,
          invoiceStatusId: data.invoiceStatusId,
          numberDocument: data.numberDocument
        }
      };
      this.fieldsToUpdate['products'] = data.products;
      this.message = await this.serviceBase.update(id, this.fieldsToUpdate);

      this.messageService.add({
        severity: 'success',
        summary: 'Orden de compra Aprobada',
        detail: 'Se aprobó Orden de Compra con exito.'
      });
    }
    if (action == 'reject') {
      this.displayResponsive = false;
      const id = data.id;

      this.fieldsToUpdate = {
        document: {
          delivery_at: data.delivery_at,
          providerId: data.providerId,
          paymentTermsId: data.paymentTermsId,
          taxId: data.taxId,
          orderStatusId: 3,
          receptionStatusId: data.receptionStatusId,
          invoiceStatusId: data.invoiceStatusId,
          numberDocument: data.numberDocument
        }
      };
      this.fieldsToUpdate['products'] = data.products;
      this.message = await this.serviceBase.update(id, this.fieldsToUpdate);
    }
    if (action == 'delete') {
      const id = data.id;
      this.message = await this.serviceBase.delete(id);
    }

    if (action == 'complete') {
      this.precioTotal = 0;
      for (const item of data['products']) {
        this.precioTotal += Number(item['netTotal']);
      }
      const productsFilter = this.dataReception.filter(
        (row) => row['purchaseOrderDocumentId'] === data['id']
      );
      this.detail = [];
      for (const items of productsFilter) {
        for (const product of items['products']) {
          const item = {
            productOfProviderId: product.productOfProviderId,
            quantity: product.quantity,
            lot: product.lot,
            expAt: product.expAt.substr(0, 10),
            purchasePrice: product.purchasePrice
          };
          this.detail.push(item);
        }
      }

      const requestAPI = {
        document: {
          providerId: data['providerId'],
          typeVoucherId: 2,
          amount: this.precioTotal,
          numberDocument: data['numberDocument'] + '    '
        },
        details: this.detail
      };

      this.message = { message: 'Completando Orden de Compra' };
      this.message = await this.purchasesService.register(requestAPI);
      const id = data.id;

      this.fieldsToUpdate = {
        document: {
          delivery_at: data.delivery_at,
          providerId: data.providerId,
          paymentTermsId: data.paymentTermsId,
          taxId: data.taxId,
          orderStatusId: 5,
          receptionStatusId: data.receptionStatusId,
          invoiceStatusId: data.invoiceStatusId,
          numberDocument: data.numberDocument
        }
      };
      this.fieldsToUpdate['products'] = data.products;
      this.message = await this.serviceBase.update(id, this.fieldsToUpdate);
    }
  }

  approvePurchaseOrder() {
    this.confirmSettings = {
      message: 'Aprobar Orden de Compra',
      action: 'approve',
      data: this.data
    };
  }

  rejectPurchaseOrder() {
    this.confirmSettings = {
      message: 'Rechazar Orden de Compra',
      action: 'reject',
      data: this.data
    };
  }

  completePurchaseOrder() {
    this.confirmSettings = {
      message: 'Completar Orden de Compra',
      action: 'complete',
      data: this.data
    };
  }

  parseToTable(data) {
    const dataTable = data.map((item) => {
      return {
        ...item,
        orderStatusName: ORDERSTATUS_ID[item.orderStatusId],
        invoiceStatusName: INVOICESTATUS_ID[item.invoiceStatusId],
        receptionStatusName: RECEPTIONSTATUS_ID[item.receptionStatusId]
      };
    });
    this.table.data = dataTable;
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
